import { render, staticRenderFns } from "./withoutLayout.vue?vue&type=template&id=3a1a7393"
import script from "./withoutLayout.vue?vue&type=script&lang=ts"
export * from "./withoutLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports